import { removeFromObject } from '../utilities/common';
import { getParametersFromQuote } from '../utilities/userdata/userDataUtils';
import * as apiTypes from '../constants/Api';
import * as apiPersonalTypes from '../constants/personal-api';
import { getParameterCaseInsensitive } from '../utilities/api/common';

export const apiHandler = (state, action) => {
  switch (action.type) {
    case (apiTypes.SERVICES_LOADING): {
      return {
        ...state,
        servicesRunning: true,
      };
    }
    case (apiTypes.SERVICES_LOADED): {
      return {
        ...state,
        servicesRunning: false,
      };
    }
    case (apiTypes.CUSTOMER_CREATE): {
      return {
        ...state,
        isUpdatingCustomer: true,
        // Allow for check if car is not part of the flow.
        noCar: state.basketList.indexOf('car') === -1,
      };
    }
    case (apiTypes.CUSTOMER_CREATED): {
      const pl = getParameterCaseInsensitive(action, 'payload');
      const cust = getParameterCaseInsensitive(pl, 'customer');
      const rolePlayerId = getParameterCaseInsensitive(cust, 'roleplayerid');
      return {
        ...state,
        rolePlayerId,
        isUpdatingCustomer: false,
      };
    }
    case (apiTypes.CUSTOMER_UPDATE):
    case (apiTypes.CUSTOMER_GET_ACTIVATION_DATE): {
      return {
        ...state,
        isUpdatingCustomer: true,
      };
    }
    case (apiTypes.CUSTOMER_UPDATED): {
      const { payload } = action;
      return {
        ...state,
        user: {
          ...state.user,
          ...payload,
        },
        isUpdatingCustomer: false,
      };
    }
    case (apiTypes.CUSTOMER_RECEIVED_ACTIVATION_DATES):
    case (apiTypes.CUSTOMER_RECEIVED_ACTIVATION_DATE): {
      const { payload } = action;
      let activationDateData = {...payload};
      return {
        ...state,
        ...activationDateData,
        isUpdatingCustomer: false,
      };
    }
    case (apiTypes.HOUSEHOLD_COV_STATE_UPDATED):
    case (apiTypes.HOUSEHOLD_AUX_UPDATED):
    case (apiTypes.CAR_UPDATE_MILEAGE): {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    }
    case (apiTypes.CUSTOMER_QUOTE):
    case (apiTypes.UPDATE_QUOTE): {
      return {
        ...state,
        isUpdatingCustomer: true,
        isCalculatingPrice: true,
      };
    }
    case (apiTypes.CUSTOMER_QUOTED): {
      const { payload } = action;
      let formatPrice = '';
      let params = '';
      let defaults = {};
      if (Object.hasOwnProperty.call(payload, 'priceApiResponse')) {
        const { priceApiResponse: { offeredPrice: { priceWithFee } } } = payload;
        formatPrice = priceWithFee;
        params = getParametersFromQuote(payload, state);
        defaults = getParametersFromQuote(payload, state, null, true);

        if (!state.quotes) {
          defaults.default = { ...defaults };
        }

        defaults.price = formatPrice;
      } else {
        Object.keys(payload).forEach((packageId) => {
          params = getParametersFromQuote(payload[packageId], state, packageId);
          const def = getParametersFromQuote(payload[packageId], state, packageId, true);
          def.usedParams = {};
          def.usedParams.coverageCodes = payload[packageId].usedParams.coverageCodes;

          if (!state.quotes) {
            defaults.default = { ...def };
          } else if (state.quotes.defaults) {
            defaults = { ...state.quotes.defaults, ...defaults };
          }

          defaults[packageId] = { ...def };
        });
      }

      return {
        ...state,
        price: formatPrice,
        quotes: {
          ...(state.quotes || {}),
          ...state.user,
          ...payload,
          defaults,
        },
        ...params,
        isUpdatingCustomer: false,
        isCalculatingPrice: false,
      };
    }
    case (apiTypes.UPDATED_QUOTE): {
      const { payload } = action;
      const { quotes } = state;
      let params = '';
      let formatPrice = '';
      if (Object.hasOwnProperty.call(payload, 'totalOfferedPrice')) {
        const { totalOfferedPrice: { priceWithFee }, usedParams } = payload;
        formatPrice = priceWithFee;
        params = getParametersFromQuote(payload, state);
        if (!usedParams.policyID) {
          // Update standard default values.
          quotes.defaults = getParametersFromQuote(payload, state, null, true);
          quotes.defaults.price = formatPrice;
        } else {
          // Use configurables as temporary data storage until user has decided save changes.
          quotes.configurables = getParametersFromQuote(payload, state, null, true);
          quotes.configurables.price = formatPrice;
        }
      } else {
        Object.keys(payload).forEach((packageId) => {
          params = getParametersFromQuote(payload[packageId], state, packageId);
          const defaults = getParametersFromQuote(payload[packageId], state, packageId, true);
          const genericDefault = quotes.defaults[packageId];
          const { usedParams } = quotes.defaults[packageId];
          const packagePayload = payload[packageId].usedParams;
          quotes.defaults[packageId] = { ...genericDefault, ...defaults };
          quotes.defaults[packageId].usedParams = { ...usedParams, ...packagePayload };
        });
      }

      return {
        ...state,
        price: formatPrice,
        quotes: {
          ...quotes,
          ...state.user,
          ...payload,
        },
        ...params,
        isUpdatingCustomer: false,
        isCalculatingPrice: false,
      };
    }
    case (apiTypes.CVR_VALID): {
      const { payload } = action;
      return {
        ...state,
        ...payload,
        isUpdatingCvr: true,
      };
    }
    case (apiTypes.CVR_VALIDATED): {
      const { payload } = action;
      let newState = state;
      if (!payload.cvrNumberValid) {
        // Delete cvr details if the cvr number is not valid.
        newState = removeFromObject(state, ['name', 'cvr', 'address', 'city', 'postalCode']);
      }
      return {
        ...newState,
        ...payload,
        isUpdatingCvr: false,
      };
    }
    case (apiTypes.CAR_REGISTRATION_NUMBER_VALID): {
      const { payload } = action;
      return {
        ...state,
        ...payload,
        isUpdatingCar: true,
      };
    }
    case (apiTypes.CAR_REGISTRATION_NUMBER_VALIDATED): {
      const { payload } = action;
      let newState = state;
      if (!payload.registrationNumberValid) {
        // Delete vehicle details if the registration number is not valid.
        newState = removeFromObject(state, ['vehicleMakeId', 'model', 'make', 'modelYear']);
      }
      return {
        ...newState,
        ...payload,
        isUpdatingCar: false,
      };
    }
    case (apiTypes.CAR_CREATE):
    case (apiTypes.CAR_UPDATE):
    case (apiTypes.CAR_PREPARE): {
      return {
        ...state,
        isUpdatingCar: true,
      };
    }
    case (apiTypes.CAR_CREATED):
    case (apiTypes.CAR_UPDATED): {
      const { payload } = action;
      return {
        ...state,
        car: {
          ...payload,
        },
        isUpdatingCar: false,
      };
    }
    case (apiTypes.CAR_PREPARED): {
      const { payload } = action;
      return {
        ...state,
        car: {
          ...state.car,
          ...payload,
        },
        isUpdatingCar: false,
      };
    }
    case (apiTypes.PAYMENT_CREATED): {
      const { payload } = action;
      return {
        ...state,
        paymentStatus: payload.status,
      }
    }
    case (apiTypes.TRAVEL_AUX_GET_PRICE_REQUESTED): {
      const { payload } = action;
      return {
        ...state,
        ...payload,
        isUpdatingTravel: false,
      };
    }
    case (apiTypes.TRAVEL_AUX_GET_PRICE_REQUEST):
    case (apiTypes.TRAVEL_CREATE):
    case (apiTypes.TRAVEL_UPDATE):
    case (apiTypes.TRAVEL_PREPARE): {
      return {
        ...state,
        isUpdatingTravel: true,
      };
    }
    case (apiTypes.TRAVEL_CREATED): {
      const { payload } = action;
      return {
        ...state,
        travel: {
          ...payload,
        },
        isUpdatingTravel: false,
      };
    }
    case (apiTypes.TRAVEL_UPDATED):
    case (apiTypes.TRAVEL_PREPARED): {
      const { payload } = action;
      return {
        ...state,
        travel: {
          ...state.travel,
          ...payload,
        },
        isUpdatingTravel: false,
      };
    }
    case (apiTypes.PURCHASE): {
      return {
        ...state,
        isUpdatingCustomer: true,
        isPurchase: true,
      };
    }
    case (apiTypes.PURCHASED): {
      const { payload } = action;
      return {
        ...state,
        policyNumber: payload,
        isUpdatingCustomer: false,
        isPurchase: false,
      };
    }
    case (apiTypes.HOUSEHOLD_CREATE):
    case (apiTypes.HOUSEHOLD_UPDATE):
    case (apiTypes.HOUSEHOLD_ADDRESS_RECEIVE_ERROR): {
      return {
        ...state,
        isUpdatingHouseholdError: true,
      };
    }
    case (apiTypes.HOUSEHOLD_ADDRESS_RECEIVED_ERROR): {
      const { payload } = action;
      return {
        ...state,
        ...payload,
        isUpdatingHouseholdError: false,
      };
    }
    case (apiTypes.HOUSEHOLD_ADDRESS_RECEIVE): {
      return {
        ...state,
        isUpdatingHousehold: true,
      };
    }
    case (apiTypes.HOUSEHOLD_ADDRESS_RECEIVED): {
      const { payload } = action;
      return {
        ...state,
        ...payload.house,
        isUpdatingHousehold: false,
      };
    }
    case (apiTypes.HOUSEHOLD_CREATED): {
      const { payload } = action;
      return {
        ...state,
        household: {
          ...payload,
        },
        isUpdatingHousehold: false,
      };
    }
    case (apiTypes.HOUSEHOLD_UPDATED):
    case (apiTypes.HOUSEHOLD_PREPARE):
    case (apiTypes.HOUSEHOLD_PREPARED): {
      const { payload } = action;
      return {
        ...state,
        household: {
          ...state.household,
          ...payload,
        },
        isUpdatingHousehold: false,
      };
    }
    case (apiPersonalTypes.PERSONAL_CREATE):
    case (apiPersonalTypes.PERSONAL_UPDATE):
    case (apiPersonalTypes.PERSONAL_PREPARE): {
      return {
        ...state,
        isUpdatingPersonal: true,
      };
    }
    case (apiPersonalTypes.PERSONAL_CREATED):
    case (apiPersonalTypes.PERSONAL_UPDATED): {
      const { payload } = action;
      return {
        ...state,
        personal: {
          ...payload,
        },
        isUpdatingPersonal: false,
      };
    }
    case (apiTypes.BANK_ACCOUNT_VALID): {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    default:
      return {};
  }
};